import Vue from "vue";
import {
  ValidationProvider,
  extend,
  ValidationObserver,
  configure,
} from "vee-validate";
import { required, max, is, size, ext, image } from "vee-validate/dist/rules";

import { getCapsPercentage } from "@/utils";

const MIN_STRING_LENGTH = 11;

const config = {
  mode: "lazy",
};

extend("max", {
  ...max,
  message(fname, param) {
    return `Значение этого поля не должно превышать ${param.length} символов`;
  },
});
extend("is", is);
extend("size", {
  ...size,
  message(fname, param) {
    return `Размер файла ${param._value_.name} не должен превышать ${
      param.size * 0.001
    } МБ`;
  },
});
extend("ext", {
  ...ext,
  message(field, params) {
    return `Формат файла ${params._value_.name} не соответствует допустимым`;
  },
});
extend("image", {
  ...image,
  message() {
    return `Загруженный файл не является изображением`;
  },
});
extend("required", {
  ...required,
  message: "Это обязательное поле",
});

extend("caps-count-limit", {
  validate(value, { limit }) {
    const numLimit = Number(limit);
    if (!numLimit || !value || value.length <= MIN_STRING_LENGTH) return true;
    const percentage = getCapsPercentage(value);
    return percentage <= numLimit;
  },
  params: ["limit"],
  message:
    "По правилам Таланта мы не можем опубликовать такое названием. Измените его, чтобы заглавные буквы составляли менее {limit}% от количества текста.",
});

// Sets the options.
configure(config);
// Register it globally
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
